export default __webpack_public_path__ + "static/media/ntfs.691df5b9.svg";